module.exports = {
	"sitedownloads": "https://interactive-genfyansford.appspot.com/dev/sitedownloads",
	"masterplan": "https://interactive-genfyansford.appspot.com/dev/masterplan",
	"precinctplan": "https://interactive-genfyansford.appspot.com/dev/precinctplan",
	"stageplan": "https://interactive-genfyansford.appspot.com/dev/stageplan",
	"lotplan": "https://interactive-genfyansford.appspot.com/dev/lotplan",
	"landsearch": "https://interactive-genfyansford.appspot.com/dev/landsearch",
	"searchfields": "https://interactive-genfyansford.appspot.com/dev/searchfields",
	"packagesearch": "https://interactive-genfyansford.appspot.com/dev/packagesearch",
	"package": "https://interactive-genfyansford.appspot.com/dev/package",
	"location": "https://interactive-genfyansford.appspot.com/location",
	"spacerimage": "https://storage.googleapis.com/genfyansford.data.insiteinteractive.com.au/assets/images/spacer.png",
	"loadingimage": "https://storage.googleapis.com/genfyansford.data.insiteinteractive.com.au/assets/images/loading.gif",
	"googlemapsapikey": "AIzaSyB5h-u50GL0Ee6xVr93-vQdXWj_7yJahAQ",
	"activestatus": [
		1,
		3
	],
	"locationname": "GenFyansFord",
	"mapresetlevel": 15,
	"mapcenterlat": -38.140685,
	"mapcenterlong": 144.303052,
	"houseandlandpath": "/house-land/",
	"sitedownloadtitle": "Everything you <br/>need to know",
	"locationgroups": [
		"",
		"",
		"education",
		"community-services",
		"shopping-centres",
		"parks-recreation",
		""
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/config.json
 ** module id = 7
 ** module chunks = 0
 **/